import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordEmail.css';
import axios from 'axios';

export default function ForgotPasswordEmail() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  
    const handleSubmit = async(e) => {
        e.preventDefault();
        try{
            const res = await axios.post(`${process.env.REACT_APP_URL}/api/forgot-password`, { email });
            if(res.data.success){
                localStorage.setItem('queryemail', email);
                alert("Password reset OTP sent to your email!");
                navigate('/Reset-Password-OTP'); // Navigate to OTP verification page
            }   

        } catch (error) {
            console.error('Error sending reset link:', error);
            alert("Failed to send reset link. Please try again.");
        }
    };

  return (
    <>
        <h1>Forgot Password</h1>
        <p>Enter your email to receive a password reset link.</p>
        <form action="#" onSubmit={handleSubmit} method="post">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" onChange={(e) => setEmail(e.target.value)} required />
            <button type="submit">Send Reset Link</button>
        </form>
    </>
  )
}